import { ApiProperty } from '@nestjs/swagger'
import { IsEnum } from 'class-validator'
import { ContentVisibility } from '../../enums/content.enum'

/**
 * DTO pour changer la visibilité d'un contenu pédagogique
 */
export class SetVisibilityDto {
  @ApiProperty({
    description: 'Nouvelle visibilité du contenu',
    enum: ContentVisibility,
    example: ContentVisibility.ESTABLISHMENT,
  })
  @IsEnum(ContentVisibility)
  visibility!: ContentVisibility
}
